import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';
import Icon from 'components/commons/icon/Icon';

type Props = {
  hideModal: () => void;
  isShowModal: boolean;
};

// MEMO: MONO(資産データリンク)側の障害対応による利用停止中モーダル
//       consts.IS_MONO_SUSPENDED が true の間に表示する
export const MonoSuspendedModal = ({
  hideModal: hide,
  isShowModal: isShow,
}: Props): React.ReactElement => {
  return (
    <Modal2 isShow={isShow}>
      <div className="p-4 max-h-modal overflow-y-auto">
        <div className="flex flex-col text-bluegray-700">
          <div className="flex flex-row">
            <Icon
              name="alert"
              className="flex items-center h-5 text-red pr-2"
            />
            <div className="font-bold text-lg">
              現在、口座連携機能の利用を停止しています
            </div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="mt-4 text-sm">
            資産データリンクのシステム障害により、
            <br />
            口座連携、登録口座の編集・削除を一時的に停止しております。
            <br />
            <br />
            ご不便をおかけしておりますが、復旧までお待ちください。
          </div>
          <button
            className="mt-6 mb-2 p-2 font-bold text-gray-500 justify-center w-full text-sm"
            onClick={hide}>
            閉じる
          </button>
        </div>
      </div>
    </Modal2>
  );
};
